import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { AiAssistantModule } from 'src/app/shared/ai-assistant/ai-assistant.module';
import { UploadCandidateDocumentComponent } from './upload-candidate-document.component';

@NgModule({
  declarations: [UploadCandidateDocumentComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    AiAssistantModule,
    DropzoneModule
  ],
  exports: [UploadCandidateDocumentComponent],
  entryComponents: [UploadCandidateDocumentComponent]
})
export class UploadCandidateDocumentModule { }
